// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ao-z","image":"Bo-z","lazyLoadPicture":"Co-z","lazyLoadSpinner":"Do-z","lazyLoadSpin":"Eo-z","lazyLoadImage":"Fo-z","hasStyledAspectRatio":"Go-z"};